"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapHasAutoSubscription = void 0;
var _mapCanBeSold = require("./mapCanBeSold");
var _mapCanBeSubscribed = require("./mapCanBeSubscribed");
const mapHasAutoSubscription = labels => !(0, _mapCanBeSold.mapCanBeSold)(labels) && (0, _mapCanBeSubscribed.mapCanBeSubscribed)(labels);
exports.mapHasAutoSubscription = mapHasAutoSubscription;
//# sourceMappingURL=mapHasAutoSubscription.js.map